import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { useAuth } from "../../context/AuthContext";
import Greeting from "./Greeting";
import LiveClock from "./LiveClock";
import UserFiles from "./UserFiles";
import PasswordManager from "./PasswordManager";
import NotesManager from "./NotesManager";
import UserMetadata from "./UserMetadata";
import "../../App.css";

const Dashboard = () => {
  const { user, signOut, getUserData } = useAuth();
  const [userData, setUserData] = useState(null);
  const [activeTab, setActiveTab] = useState("files");

  useEffect(() => {
    if (user) {
      const data = getUserData();
      setUserData(data);
    }
  }, [user, getUserData]);

  if (!user) return null;

  return (
    <motion.div
      className="dashboard-container"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <div className="dashboard-background" />

      <motion.div
        className="dashboard-sidebar"
        initial={{ x: -100 }}
        animate={{ x: 0 }}
        transition={{ type: "spring", stiffness: 100 }}
      >
        <div className="sidebar-header">
          <motion.div
            className="user-avatar"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            {user.username.charAt(0).toUpperCase()}
          </motion.div>
          <div>
            <h3>{user.username}</h3>
            <p>{user.email}</p>
          </div>

          <motion.button
            className="sign-out-button"
            onClick={signOut}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Sign Out
          </motion.button>
        </div>

        <nav className="sidebar-nav">
          <motion.button
            className={`nav-item ${activeTab === "files" ? "active" : ""}`}
            onClick={() => setActiveTab("files")}
            whileHover={{ x: 5 }}
          >
            My Files
          </motion.button>
          <motion.button
            className={`nav-item ${activeTab === "passwords" ? "active" : ""}`}
            onClick={() => setActiveTab("passwords")}
            whileHover={{ x: 5 }}
          >
            Password Manager
          </motion.button>
          <motion.button
            className={`nav-item ${activeTab === "notes" ? "active" : ""}`}
            onClick={() => setActiveTab("notes")}
            whileHover={{ x: 5 }}
          >
            Notes
          </motion.button>
          <motion.button
            className={`nav-item ${activeTab === "account" ? "active" : ""}`}
            onClick={() => setActiveTab("account")}
            whileHover={{ x: 5 }}
          >
            Account Info
          </motion.button>
        </nav>
      </motion.div>

      <div className="dashboard-content">
        <div className="dashboard-header">
          <Greeting username={user.username} />
          <LiveClock />
        </div>

        <motion.div
          className="tab-content"
          key={activeTab}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.3 }}
        >
          {activeTab === "files" && <UserFiles userData={userData} />}
          {activeTab === "passwords" && <PasswordManager userData={userData} />}
          {activeTab === "notes" && <NotesManager userData={userData} />}
          {activeTab === "account" && <UserMetadata userData={userData} />}
        </motion.div>
      </div>
    </motion.div>
  );
};

export default Dashboard;
